"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMD5Hash = generateMD5Hash;
/* eslint-disable @typescript-eslint/no-require-imports */
function generateMD5Hash(input) {
    const crypto = require('crypto-js');
    return crypto.MD5(input).toString();
}
